import { StyledEngineProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../store/queryClient';
import { FeatureProvider } from './components/FeatureProvider';
import { ActiveRoleProvider } from './context/ActiveRoleContext';
import { AuthProvider } from './context/AuthContext';
import { NavigationMenuProvider } from './context/NavigationMenuContext';
import AppContainer from './scenes/App';

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <StyledEngineProvider injectFirst>
        <ActiveRoleProvider>
          <FeatureProvider>
            <NavigationMenuProvider>
              <AppContainer />
            </NavigationMenuProvider>
          </FeatureProvider>
        </ActiveRoleProvider>
      </StyledEngineProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
